module.exports = __webpack_public_path__ + "img/case03.d5579bdb.jpg";